<template src="../templates/portal.html"></template>

<script>
import jQuery from 'jquery';
import entityStore from '@/store/entityStore';
import menuLeft from './partials/menuLeft';
import userAuthStore from '../store/userAuthStore';

export default {
  data() {
    return {
      userAuth: userAuthStore.state,
      entity: entityStore.state,
    };
  },
  components: {
    menuLeft,
  },
  created() {
    jQuery('body').addClass(this.entity.name);
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// portal.vue?6b463dbc